import { Button, Input, Modal, Select, Upload } from 'antd'
import React, { useEffect, useState } from 'react'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { getUserId } from '../../../helpers/auth'
import { toast } from 'react-toastify'
import Loader from '../../../pages/pages/loader'
import CampaignDropdown from '../../CampaignDropdown'
import LanguageDropdown from '../../LanguageDropdown'
import {
  useCreateCampaignKeywordMutation,
  useUpdateCampaignKeywordMutation
} from '../../../redux/apis/campaignsManagement/keywords/cMKeywordsApiSlice'

const EditCreateCampaignKeywordsModal = ({
  keyword,
  open,
  setOpen,
  isEdit = false,
  setHolder,
  setIsEdit
}) => {
  const [create, { isLoading, isSuccess, error }] =
    useCreateCampaignKeywordMutation()
  const [
    update,
    { isLoading: updateLoading, isSuccess: updateSuccess, error: updateError }
  ] = useUpdateCampaignKeywordMutation()

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      campaign_keyword: keyword?.campaign_keyword || '',
      campaign: keyword?.campaign?.id || '',
      language: keyword?.language?.id || '',
      keyword_status: isEdit ? keyword?.keyword_status ? true : false :true,
      last_updated_by: getUserId()
    },

    validationSchema: Yup.object({
      campaign_keyword: Yup.string().required('Please Enter Campaign Keyword '),
      campaign: Yup.number().required('Please Enter Campaign '),
      language: Yup.number().required('Please Enter Campaign Language'),
      keyword_status: Yup.boolean().required('Please Select Campaign Status')
    }),

    onSubmit: async values => {
      try {
        if (isEdit) {
          await update({ id: keyword?.id, body: values }).unwrap()
        } else {
          await create(values)
        }
      } catch (error) {
        console.error(error)
      }
    }
  })

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    } else if (updateError?.data) {
      const errorMessages = Object.values(updateError.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error, updateError])

  useEffect(() => {
    if (isSuccess) {
      toast.success('Campaign Keyword Added!')
      setOpen(false)
      validation.resetForm()
    } else if (updateSuccess) {
      toast.success('Campaign Keyword Updated!')
      setOpen(false)
      validation.resetForm()
    }
  }, [isSuccess, updateSuccess])
  return (
    <>
      <Loader isLoading={isLoading || updateLoading} />
      <div className='flex w-full justify-end'>
        <button
          className='btn btn-outline-theme mb-4'
          onClick={() => {
            setHolder()
            setIsEdit(false)
            setOpen(true)
          }}
        >
          Create New Campaign Keyword
        </button>
      </div>
      <Modal
        open={open}
        title={isEdit ? 'Edit Campaign Keyword' : 'Create New Campaign Keyword'}
        onCancel={() => setOpen(false)}
        footer={[
          <Button key='back' onClick={() => setOpen(false)}>
            Cancel
          </Button>,
          <Button
            key='submit'
            type='primary'
            onClick={() => {
              if (Object.keys(validation.errors).length !== 0) {
                Object.keys(validation.errors).map(key => {
                  toast.error(validation.errors[key])
                })
                return
              }
              validation.handleSubmit()
            }}
          >
            Submit
          </Button>
        ]}
      >
        <div className='gap-8 '>
          <div className=' mb-3 flex-1'>
            <label className="form-label">Keyword Name</label>
            <Input
              type='text'
              name='campaign_keyword'
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.campaign_keyword}
            />
            {validation.touched.campaign_keyword &&
            validation.errors.campaign_keyword ? (
              <p className='text-danger'>
                {validation.errors.campaign_keyword}
              </p>
            ) : null}
          </div>
          <CampaignDropdown
            onBlur={validation.handleBlur}
            onChange={e => {
              validation.setFieldValue('campaign', e)
            }}
            value={validation.values?.campaign}
          />
          {validation.touched.campaign && validation.errors.campaign ? (
            <p className='text-danger'>{validation.errors.campaign}</p>
          ) : null}
          <LanguageDropdown
            onBlur={validation.handleBlur}
            onChange={e => {
              validation.setFieldValue('language', e)
            }}
            value={validation.values?.language}
          />
          {validation.touched.language && validation.errors.language ? (
            <p className='text-danger'>{validation.errors.language}</p>
          ) : null}

          <div className=' mb-3 flex-1'>
            <label>Campaign keyword Status</label>
            <br />
            <Select
              className={''}
              name='keyword_status'
              style={{
                width: '100%'
              }}
              defaultValue={validation?.values?.keyword_status}
              value={validation?.values?.keyword_status}
              onChange={e => validation.setFieldValue('keyword_status', e)}
              onBlur={validation.handleBlur}
              options={[
                {
                  label: 'Active',
                  value: true
                },
                {
                  label: 'Inactive',
                  value: false
                }
              ]}
            />
            {validation.touched.keyword_status && validation.errors.keyword_status ? (
              <p className='text-danger'>{validation.errors.keyword_status}</p>
            ) : null}
          </div>
        </div>
      </Modal>
    </>
  )
}

export default EditCreateCampaignKeywordsModal
